import {AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {forbiddenPassword} from '../../shared/password.validator';
import {verifiedInvalid} from '../../shared/helpers';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {GetUserResponse} from '../../shared/getUser.response';
import {MatStepper} from '@angular/material/stepper';
import {ActiveUserRequest} from '../../shared/activeUser.request';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import { expRegEmail } from 'src/app/shared/email.regex';

@Component({
  selector: 'app-activar-usuario',
  templateUrl: './activar-usuario.component.html',
  styleUrls: ['./activar-usuario.component.scss']
})
export class ActivarUsuarioComponent implements OnInit, AfterViewInit {
  username: string;
  userActive = false;
  showPassword = false;
  data: GetUserResponse;
  prev?: GetUserResponse;
  activarForm: FormGroup;
  userForm: FormGroup;
  empresaForm: FormGroup;
  credencialesForm: FormGroup;
  snackbarConfig: MatSnackBarConfig = {panelClass: 'account-request-snackbar', duration: 5000};
  regiones = [
    {
      name: 'Región de Arica y Parinacota',
      id: 15
    },
    {
      name: 'Región de Tarapacá',
      id: 1
    }, {
      name: 'Región de Antofagasta',
      id: 2
    }, {
      name: 'Región de Atacama',
      id: 3
    }, {
      name: 'Región de Coquimbo',
      id: 4
    }
    , {
      name: 'Región Metropolitana de Santiago',
      id: 13
    }, {
      name: 'Región de Valparaíso',
      id: 5
    }, {
      name: 'Región del Libertador Gral. Bernardo O\'Higgins',
      id: 6
    }, {
      name: 'Región del Maule',
      id: 7
    }, {
      name: 'Región de Ñuble',
      id: 16
    },
    {
      name: 'Región del Biobío',
      id: 8
    },
    {
      name: 'Región de La Araucanía',
      id: 9
    },
    {
      name: 'Región de Los Ríos',
      id: 14
    },
    {
      name: 'Región de Los Lagos',
      id: 10
    },
    {
      name: 'Región de Los Lagos',
      id: 10
    },
    {
      name: 'Región de Los Lagos',
      id: 10
    }, {
      name: 'Región de Aysén',
      id: 11
    },
    {
      name: 'Región de Magallanes',
      id: 12
    },
  ];
  @ViewChild(MatStepper) stepper: MatStepper;


  constructor(private titleService: Title,
              private activeRoute: ActivatedRoute,
              private fb: FormBuilder,
              private service: AuthenticationService,
              private router: Router,
              private snackbar: MatSnackBar
  ) {
    const user = this.service.approvedUser.value;
    this.titleService.setTitle('Activar usuario');
    if (user) {
      this.username = user;
      this.initFormsData();
      this.service.approvedUser.next(undefined);
    } else {
      this.router.navigate(['login']);
    }
  }

  ngOnInit(): void {
    this.userForm = this.fb.group(
      {
        name: ['', [Validators.required, Validators.minLength(1)]],
        lastnames: ['', [Validators.required, Validators.minLength(1)]],
        phone: ['', [Validators.required, Validators.pattern(/^(\+?56)?(\s?)(0?[92])(\s?)[987654321]\d{7}$/)]],
      }
    );
    this.empresaForm = this.fb.group(
      {
        name: ['', Validators.required],
        address: ['', [Validators.required, Validators.pattern(/.*[^ ].*/)]],
        rut: ['', Validators.required],
        city: ['', [Validators.required, Validators.pattern(/.*[^ ].*/)]],
      }
    );
    this.credencialesForm = this.fb.group(
      {
        username: [this.username, Validators.required],
        email: ['', [Validators.required, Validators.pattern(expRegEmail)]],
        password: [undefined, [Validators.required]],
        confirm: ['', [Validators.required]],
      }
    );
    this.password.addValidators(forbiddenPassword());
    this.confirmPassword.addValidators(forbiddenPassword(13, this.password));
    this.password.valueChanges.subscribe(() => {
      this.confirmPassword.updateValueAndValidity();
    });
    this.activarForm = this.fb.group({
        account: this.fb.array([
          this.userForm, this.empresaForm, this.credencialesForm
        ])
      }
    );
  }

  ngAfterViewInit() {
    this.stepper._getIndicatorType = () => 'number';
  }

  @HostListener('window:beforeunload')
  clean() {
    if (!this.userActive) {
      this.updateUser(true);
    }
  }

  initFormsData() {
    this.service.getUser({username: this.username}).then(resp => {
      this.data = resp;
      if (!this.prev) {
        this.prev = this.data;
      }
      this.loadData();
    }).catch(() => {
      this.router.navigate(['login']);
    });

  }

  loadData(): void {
    this.userForm.get('name').setValue(this.data.datos.nombre);
    this.userForm.get('lastnames').setValue(this.data.datos.apellido);
    this.userForm.get('phone').setValue(this.data.datos.telefono);
    this.empresaForm.get('name').setValue(this.data.datos.proveedor.nombre);
    this.empresaForm.get('rut').setValue(this.data.datos.proveedor.rut);
    this.credencialesForm.get('email').setValue(this.data.datos.email);
    this.empresaForm.get('address').setValue(this.data.direccion.direccion);
    this.empresaForm.get('city').setValue(this.data.direccion.comuna);

  }

  get invalidName(): boolean {
    return verifiedInvalid(this.userForm.get('name'));
  }

  get invalidLastnames(): boolean {
    return verifiedInvalid(this.userForm.get('lastnames'));
  }

  get invalidPhone(): boolean {
    return verifiedInvalid(this.userForm.get('phone'));
  }

  get invalidAddress(): boolean {
    return verifiedInvalid(this.empresaForm.get('address'));
  }

  get invalidEmail(): boolean {
    return verifiedInvalid(this.credencialesForm.get('email'));
  }

  get invalidCity(): boolean {
    return verifiedInvalid(this.empresaForm.get('city'));
  }

  get password(): AbstractControl {
    return this.credencialesForm.get('password');
  }

  get confirmPassword(): AbstractControl {
    return this.credencialesForm.get('confirm');
  }

  get invalidPassword(): boolean {
    return verifiedInvalid(this.password);
  }

  get invalidConfirmPassword(): boolean {
    return verifiedInvalid(this.confirmPassword);
  }

  get passwordErrors(): ValidationErrors {
    return this.password.errors;
  }

  get confirmPasswordErrors(): ValidationErrors {
    return this.confirmPassword.errors;
  }

  updateUser(reset = false, activado: boolean = false, error?: () => void): void {
    let req: ActiveUserRequest = {
      id_usuario: this.prev.datos.id_usuario,
      activo: activado,
      nombre: this.userForm.get('name').value,
      apellido: this.userForm.get('lastnames').value,
      username: this.credencialesForm.get('username').value,
      email: this.credencialesForm.get('email').value,
      telefono: this.userForm.get('phone').value,
      contrasena: this.password.value,
      direccion: this.empresaForm.get('address').value,
      comuna: this.empresaForm.get('city').value
    };
    if (reset) {
      req = {
        id_usuario: this.prev.datos.id_usuario,
        activo: false,
        nombre: this.prev.datos.nombre,
        apellido: this.prev.datos.apellido,
        username: this.username,
        email: this.prev.datos.email,
        telefono: this.prev.datos.telefono,
        contrasena: undefined,
        direccion: this.prev.direccion.direccion,
        comuna: this.prev.direccion.comuna
      };
    }
    this.service.activeUser(req).then((resp) => {
      if (!activado) {
        this.username = resp.user.username;
        this.credencialesForm.get('username').setValue(this.username);
        this.initFormsData();
      } else if (!reset) {
        this.userActive = true;
        this.router.navigate(['/mensaje']);
      }
    }).catch(() => {
      if (error) {
        error();
      }
    });
  }

  cancel() {

    this.router.navigate(['/login']);
    this.updateUser(true, false, () => {
      this.snackbar.open('Ha ocurrido un error intentando revertir los cambios de su usuario', 'cerrar',
        this.snackbarConfig);
    });
  }

  updateUsername(): void {
    if (this.userForm.get('lastnames').value.length !== 0
      && this.userForm.get('name').value.length !== 0 &&
      (this.userForm.get('name').value !== this.data.datos.nombre ||
        this.userForm.get('lastnames').value !== this.data.datos.apellido)) {

      this.credencialesForm.patchValue({
        username: `${this.userForm.get('name').value.charAt(0)}${this.userForm.get('lastnames').value}`
      });
    }
  }

  submit(): void {
    this.updateUser(false, true, () => {
      this.snackbar.open('Ha ocurrido un error intentando activar su usuario', 'cerrar',
        this.snackbarConfig);
    });
  }
}
